import React from 'react';

function Terms() {
  return (
    <div className="container my-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h1 className="card-title text-center mb-4">Terms and Conditions</h1>

          <section className="mb-5">
            <h3 className="mb-3">Introduction</h3>
            <p>
              Welcome to our Human Resource Management (HRM) system. These terms and conditions outline
              the rules and regulations for the use of our software. By accessing this application, we
              assume you accept these terms and conditions. Do not continue to use the HRM system if
              you do not agree to all the terms and conditions stated on this page.
            </p>
          </section>

          <section className="mb-5">
            <h3 className="mb-3">User Responsibilities</h3>
            <p>
              As a user of this HRM system, you are responsible for ensuring that all information provided
              is accurate and up-to-date. Any misuse of the system, including but not limited to unauthorized
              access, is strictly prohibited and may result in legal consequences.
            </p>
          </section>

          <section className="mb-5">
            <h3 className="mb-3">Data Protection</h3>
            <p>
              We are committed to protecting your privacy and ensuring that all personal data collected is
              handled in accordance with applicable data protection laws. For more information, please review
              our Privacy Policy.
            </p>
          </section>

          <section className="mb-5">
            <h3 className="mb-3">Limitation of Liability</h3>
            <p>
              The HRM system is provided “as is” without any warranties, expressed or implied. In no event
              shall we be liable for any damages arising from the use of this software.
            </p>
          </section>

          <section className="mb-5">
            <h3 className="mb-3">Termination</h3>
            <p>
              We reserve the right to terminate your access to the HRM system at any time, without notice,
              for conduct that we believe violates these terms or is harmful to other users.
            </p>
          </section>

          <section className="mb-5">
            <h3 className="mb-3">Changes to Terms</h3>
            <p>
              We may revise these terms and conditions from time to time. Continued use of the HRM system
              following any changes will indicate your acceptance of the revised terms.
            </p>
          </section>

          <footer className="text-center">
            <p>© 2024 HRM Software. All rights reserved.</p>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Terms;
